import React from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Page404 from "./views/Page404";
import ForgotPassword from "./views/ForgotPassword";
import ResetPassword from "./views/ResetPassword";
import Login from "./views/Login/Login";
import Logout from "./views/Logout";
import Register from "./views/Register";
import SurveyForm from "features/survey/views/Form/Form";
import PrivateRoute from "commons/router/PrivateRoute";
import { roles } from "commons/auth/roles";
import {
  ROUTES_CORE,
  ROUTES_USERS,
  ROUTES_DASHBOARD,
  ROUTES_SURVEY,
} from "commons/constants/paths";
import HomeDefault from "./views/Home/Default";
import Dashboard from "features/dashboard/views/Dashboard";
import UsersList from "features/users/views/UsersList";
import UserAdd from "features/users/views/UserAdd";
import UserEdit from "features/users/views/UserEdit";
import DownloadHandler from "features/download/DownloadHandler";
import { CODENAME } from "commons/constants/env";

const renderHomePage = () => {
  switch (CODENAME) {
    default: { return <HomeDefault/> }
  }
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { path: ROUTES_CORE.HOME, element: renderHomePage() },
      { path: ROUTES_CORE.FORGOT_PASSWORD, element: <ForgotPassword /> },
      { path: ROUTES_CORE.RESET_PASSWORD(':token'), element: <ResetPassword /> },
      { path: ROUTES_CORE.LOGIN, element: <Login /> },
      { path: ROUTES_CORE.LOGOUT, element: <Logout /> },
      { path: ROUTES_CORE.REGISTER, element: <Register /> },

      { path: ROUTES_SURVEY.DETAILS(':id'), element: <PrivateRoute roles={[...roles.admin, ...roles.user]}><SurveyForm /></PrivateRoute> },
      { path: ROUTES_SURVEY.DETAILS_EXTENDED(':id', ':section'), element: <PrivateRoute roles={[...roles.admin, ...roles.user]}><SurveyForm /></PrivateRoute> },
      { path: ROUTES_SURVEY.DETAILS_FULL_EXTENDED(':id', ':section', ':element'), element: <PrivateRoute roles={[...roles.admin, ...roles.user]}><SurveyForm /></PrivateRoute> },
      { path: ROUTES_SURVEY.DATA_DOWNLOAD(':id'), element: <PrivateRoute roles={[...roles.admin]}><DownloadHandler /></PrivateRoute> },

      { path: ROUTES_USERS.ADD, element: <PrivateRoute roles={roles.admin}><UserAdd /></PrivateRoute> },
      { path: ROUTES_USERS.EDIT(':id'), element: <PrivateRoute roles={roles.admin}><UserEdit /></PrivateRoute> },
      { path: ROUTES_USERS.LIST, element: <PrivateRoute roles={roles.admin}><UsersList /></PrivateRoute> },

      { path: ROUTES_DASHBOARD.DETAILS(':type'), element: <PrivateRoute roles={roles.all}><Dashboard /></PrivateRoute> },
      { path: ROUTES_DASHBOARD.DASHBOARD, element: <PrivateRoute roles={roles.all}><Dashboard /></PrivateRoute> },

      { path: '*', element: <Page404 /> },
    ],
  },
]);

export default router;